import axios from "../../axiosInstance";
import type { Badge, BadgeUpdateRequest } from "@/modules/learningCenter/features/BadgeManagement/types/badge.types";

export const updateBadge = async (id: string, data: BadgeUpdateRequest): Promise<Badge> => {
  const response = await axios.put(`/api/badges/${id}`, data);

  // Transform snake_case response to camelCase
  const transformedResponse: Badge = {
    id: response.data.id,
    name: response.data.name,
    description: response.data.description,
    iconType: response.data.icon_type,
    iconValue: response.data.icon_value,
    pointValue: response.data.point_value,
    badgeType: response.data.badge_type,
    isActive: response.data.is_active,
    createdAt: response.data.created_at,
    updatedAt: response.data.updated_at,
    createdBy: response.data.created_by,
    parentBadgeId: response.data.parent_badge_id
  };

  return transformedResponse;
};

export default updateBadge;
